import { Link } from 'react-router-dom';
import { bg, line, tx, font, accent, space, radius } from '../theme';
import { LogoLockup } from '../components/Logo';

export default function AuthLayout({ eyebrow, title, intro, children, footer }) {
  return (
    <div style={{
      minHeight: '100vh', background: bg.base,
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      padding: `${space.s6}px ${space.s5}px`,
    }}>
      <Link to="/" style={{ marginBottom: space.s8, marginTop: space.s6 }}>
        <LogoLockup markHeight={28} wordHeight={14} />
      </Link>

      <div style={{
        width: '100%', maxWidth: 400,
        background: bg.surface,
        border: `1px solid ${line.DEFAULT}`,
        borderRadius: radius.lg,
        padding: space.s6,
      }}>
        {eyebrow && (
          <div style={{
            fontFamily: font.display, fontSize: 11, fontWeight: 700,
            letterSpacing: '0.24em', textTransform: 'uppercase',
            color: accent.lime, marginBottom: space.s3,
          }}>
            {eyebrow}
          </div>
        )}
        <h1 style={{
          fontFamily: font.display, fontSize: 24, fontWeight: 700,
          letterSpacing: '0.01em', marginBottom: intro ? space.s3 : space.s5,
        }}>
          {title}
        </h1>
        {intro && (
          <p style={{ color: tx.secondary, fontSize: 14, marginBottom: space.s5 }}>
            {intro}
          </p>
        )}
        {children}
      </div>

      {footer && (
        <div style={{
          marginTop: space.s5, fontSize: 14, color: tx.muted, textAlign: 'center',
        }}>
          {footer}
        </div>
      )}
    </div>
  );
}

export function Field({ label, ...rest }) {
  return (
    <div style={{ marginBottom: space.s4 }}>
      <label style={{
        display: 'block', fontFamily: font.display, fontSize: 12, fontWeight: 600,
        letterSpacing: '0.08em', textTransform: 'uppercase',
        color: tx.muted, marginBottom: space.s2,
      }}>
        {label}
      </label>
      <input
        style={{
          width: '100%', background: bg.raised,
          border: `1px solid ${line.strong}`, borderRadius: radius.md,
          padding: '11px 14px', color: tx.primary, fontSize: 15, outline: 'none',
        }}
        onFocus={e => { e.target.style.borderColor = accent.lime; }}
        onBlur={e => { e.target.style.borderColor = line.strong; }}
        {...rest}
      />
    </div>
  );
}

export function Message({ tone = 'error', children }) {
  if (!children) return null;
  const colours = {
    error:   { color: accent.red,   bg: 'rgba(255,77,106,.08)', border: 'rgba(255,77,106,.26)' },
    success: { color: accent.green, bg: 'rgba(61,214,140,.08)', border: 'rgba(61,214,140,.26)' },
    info:    { color: accent.cyan,  bg: 'rgba(77,216,232,.08)', border: 'rgba(77,216,232,.26)' },
  }[tone];
  return (
    <div style={{
      padding: `${space.s3}px ${space.s4}px`, borderRadius: radius.md,
      background: colours.bg, border: `1px solid ${colours.border}`,
      color: colours.color, fontSize: 13.5, marginBottom: space.s4,
    }}>
      {children}
    </div>
  );
}

